import React from 'react';

import { ICurrency } from 'src/apis/common';
import NumericalPlanProperty from './NumericalPlanProperty';

export interface IProps {
  currency: ICurrency;
  label: string | React.ReactNode;
  value: number;
}

/**
 * Displays (and, in the future, will edit) a price property of a plan.
 *
 * If we ever support editing plans in the finance site, consider using <CurrencyFormInput>.
 */
const PricePlanProperty: React.FC<IProps> = (props) => {
  // Not technically "dollars", but "currency symbol amounts".
  const priceInDollars = props.value / props.currency.unitsPerSymbol;
  return <NumericalPlanProperty label={props.label} value={priceInDollars} inputPrefix={props.currency.symbol}/>;
};

export default PricePlanProperty;
